import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    if (lng === 'bg' || lng === 'en' || lng === 'de' || lng === 'ru') {
      i18n.changeLanguage(lng);
      // i18next automatically saves to localStorage with the configured key
    }
  };

  const getCurrentLanguage = () => {
    return i18n.language;
  };

  const isCurrentLanguage = (lng) => {
    return i18n.language === lng;
  };

  return {
    t,
    i18n,
    changeLanguage,
    getCurrentLanguage,
    isCurrentLanguage,
    currentLanguage: i18n.language
  };
}; 